var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BEC0C2;}\n\t.st1{fill:#002D62;}\n\t.st2{fill:#FDBB30;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348,199.8c0,81.7-66.2,148-148,148c-81.7,0-148-66.2-148-148c0-81.7,66.2-148,148-148 C281.8,51.8,348,118.1,348,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.5,199.8c0,77-62.4,139.5-139.5,139.5S60.5,276.8,60.5,199.8S123,60.3,200,60.3 C277.1,60.3,339.5,122.7,339.5,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200,66.8c-73.4,0-132.9,59.5-132.9,133c0,73.4,59.5,132.9,132.9,132.9s132.9-59.5,132.9-132.9 C333,126.4,273.4,66.8,200,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291,199.8c0,51.3-40.8,92.9-91,92.9c-50.3,0-91-41.6-91-92.9s40.7-92.9,91-92.9 C250.3,106.9,291,148.5,291,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.2,199.8c0,48-38.1,86.9-85.2,86.9c-47,0-85.2-38.9-85.2-86.9s38.1-86.9,85.2-86.9 C247.1,112.9,285.2,151.8,285.2,199.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "106.6,173.8 105.7,177.2 78.5,170.5 79.4,167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.4,132 122.1,141 120.1,143.6 97.9,126.6 99,125.1 115.1,129.3 103,120 105,117.3 127.2,134.3  126.1,135.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.6,109.5l1.5-0.8c1.5-0.7,1.7-2.1,1.2-3.2c-2.9-5.7-5-9.7-7.9-15.4c-0.6-1.2-1.9-1.6-3.1-1l-1.7,0.9 L153.6,109.5z M139,89l5.5-2.8c2.4-1.2,5.3-1.1,6.8,1.8c3.5,6.9,5.1,9.9,8.6,16.7c1.4,2.8-0.2,5.2-2.4,6.3l-5.7,2.9L139,89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "196.5,101 193,101.2 191.4,73.2 195.1,73  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.2,89.3l-0.2-0.1l-5.7,9.4l3.8,1.4L241.2,89.3z M237.3,108.4l1.2-5.4l-4.7-1.8L231,106l-3.3-1.3l14.9-24.3 l3.5,1.3l-5.3,28L237.3,108.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "278.9,119.3 268.1,129.4 265.8,127 286.2,107.8 287.4,109.1 280.7,124.4 291.9,113.9 294.2,116.3  273.8,135.5 272.5,134.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.2,162.4l-0.1-0.2l-10.9,1.5l1.3,3.8L310.2,162.4z M292.9,171.4l4.9-2.5l-1.6-4.8l-5.5,0.9l-1.1-3.4 l28.3-3.8l1.2,3.5l-25,13.6L292.9,171.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,251.8l2,3.8l9.9-5.2l-2-3.8L100.8,251.8z M88.6,258.2l-1.7-3.2l24.8-12.9l4.1,7.9 c0.8,1.6,0.4,2.8-0.8,3.4c-4.4,2.3-6.7,3.5-11.1,5.8c-1.3,0.7-2.5,0.3-3.3-1.1l-2.5-4.8L88.6,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.2,285.6l-0.2-0.2l-8.2,7.2l3.1,2.5L135.2,285.6z M125.6,302.7l2.7-4.8l-4-3.2l-4.1,3.7l-2.8-2.2 l21.5-18.7l2.9,2.3L128.5,305L125.6,302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.3,315.2l3.5,0.9l-1.8,7.2c-0.3,1.3-1.5,2-2.7,1.7c-2.5-0.6-4.2-1.1-6.8-1.7c-1.3-0.3-2-1.5-1.7-2.8 c2.2-8.9,3.4-13.8,5.6-22.7c0.3-1.3,1.5-2,2.7-1.7c2.5,0.6,4.3,1.1,6.9,1.7c1.2,0.3,1.9,1.5,1.6,2.8l-1.4,5.7l-3.5-0.8l1.2-5 l-4.2-1l-5.2,21.3l4.2,1L175.3,315.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "226.8,324.8 217.8,326.5 212.9,298.9 221.8,297.3 222.3,300.3 216.9,301.2 218.5,310.2 223.6,309.3  224.1,312.3 219.1,313.2 220.8,322.8 226.2,321.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268,307.2l-3,2L249.2,286l7.7-5.2c1.4-1,2.6-0.5,3.3,0.6c2.2,3.2,3.6,5.3,5.8,8.5c0.9,1.3,0.5,2.6-0.6,3.3 l-0.4,0.3l10.2,8.8l-3.3,2.3l-11.5-10.2l-0.1-1.3l2.4-1.6l-5.1-7.4l-3.8,2.6L268,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.5,265l5.6,3.5l1.6-2.6l-5.4-3.4l-10.4,0.5c-0.7,0-1.4,0-1.9-0.4c-2-1.3-2.9-1.9-5.1-3.2 c-1-0.6-1.4-2-0.7-3.1c1.1-1.8,2-3.2,3.2-5c0.8-1.2,2-1.3,3.1-0.6l4.9,3.1l-1.9,3l-4.3-2.7l-1.6,2.6l4.2,2.6l9.9-0.6 c1,0,1.8,0,2.5,0.5c2.6,1.7,3.5,2.2,6.2,3.9c1.1,0.7,1.5,2,0.8,3.1c-1.1,1.8-2,3.2-3.2,5c-0.6,1-1.9,1.4-3.1,0.6l-6.2-3.9 L296.5,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.8,147l-23,104.6h45.6c0,0,5.1-20.8,5.5-22.7c2,0,19.8,0,19.8,0c14.8,0.1,26.9-4.9,35.1-14.5 c14.9-16.2,12.3-39.9,1.1-53.4c-8-9.7-19.6-15.1-32.5-15.1h-51.3L172.8,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.6,224.8l-5.5,22.7h-37.2l21.5-97.3h47.9c11.9,0,22.2,4.9,29.4,13.6c10.6,12.8,11.7,34.2-1.1,48 c-7.8,9.1-19.3,13.2-31.9,13.1L197.6,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.4,172.4h21c2.4,0,5,2,3.9,5.1c-0.7,1.9-1.2,4.1-1.5,6.2c-0.2,1.6,1.6,2.6,2.6,2.6h42.8 c0.8,0,1.2-0.2,1.2-0.6c0-0.4,0-1.8-0.2-2.8c-0.2-0.9-0.3-1.1-1.1-1.1c-5.3,0-7.5-2.4-13.1-6s-13.8-5.7-20.9-5.7h-34.4L171.4,172.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.4,200.1c-0.8-1.6-1.4-3.5-1.9-5.2c-0.5-2.2-2.4-4-5.7-4h-22.5l0.6-2.5l73,0.1c0.7,0,0.6,0.3,0.5,1.1 c0,0.8-0.2,2.3-0.3,3.2s-0.8,0.7-1.5,0.7c-1.7,0-4.7,0.4-6.5,1.8c-3,2.3-9.5,6.3-13.1,7.4C216.1,203.8,201.6,208.3,197.4,200.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.3,209.3h38.1c1.7,0,3.1,0.4,4.3,1.3c3.2,2.6,7.4,4.6,11.8,5.9c2,0.6,5.4-0.2,8.5-1.9 c7.6-4.3,12.5-12.5,14.2-17.8c0.4-1.4-0.4-1.3-1.4-1.2c-3.2,0.2-6.6,3.1-11,6c-4.5,2.8-13.5,5.5-22.1,5.5h-41.8L163.3,209.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.3,158.2c0.5-0.1,2.5-0.2,3.5,0.2c7.3,2.9,14.1,10.4,17,18.4c0.6,1.6,0.7,2.5,0,2.6 c-3.3,0.4-4.8-1.3-8.8-3.9c-3.9-2.6-7.5-4.4-12.4-6c-4.9-1.5-13.8-1.8-14.9-1.8c-1.1,0-1-0.5-0.5-1 C207.4,162.4,213.1,159.3,219.3,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254,185.7c0,0.3-0.3,0.7-0.7,0.7h-8.4c-1.1,0-1.1-0.5-1.1-1.1c-0.1-0.6-0.2-1.8-0.2-2.6 c0-0.7-0.3-1.5,0.6-1.9c2.3-1,4.5-3.3,5.5-5.2c0.3-0.7,0.8-1.7,1.4-0.8C253.2,177.9,253.8,181.8,254,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251,200.7c-0.1,0.3-0.7,0.5-0.8,0c-1.2-3.3-4.1-5.5-6.1-6.6c-0.6-0.3-0.6-0.7-0.6-1.3 c0.1-0.6,0.3-2.5,0.4-3.3c0-0.6,0.3-1.1,0.8-1.1h8.7c0.3,0,0.7,0.3,0.7,0.5C254,193.1,252.8,197.2,251,200.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.4,217c-0.6,0.1-2-0.1,0.1-1.3c6.3-3.7,12-12.3,13.5-17.3c0.6-1.9,0.6-2,1.4-1.8c1,0.3,2.5,1.6,3.7,3.2 c1.2,1.6,1.7,4.8,1,5.6C243.5,211.6,236.3,215.9,228.4,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.5,178c-1.5,0.8-1.8,0.6-2.1-0.5c-2.8-9.6-10.9-16.8-14.2-18.9c-0.6-0.4-0.5-0.7,0-0.6 c7.9,1.1,15.7,5.4,19.6,11.3C250.1,172.7,245.9,177.2,244.5,178z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInd);
export default __webpack_public_path__ + "static/media/IND.6d0d6b5f612bac3f1712b53a9ac84c13.svg";
export { ForwardRef as ReactComponent };